exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".avatar-e605c{margin-right:10px}.label-a743a{font-weight:600}", ""]);

// Exports
exports.locals = {
	"avatar": "avatar-e605c",
	"label": "label-a743a"
};